import React from 'react'

import { AcornsIcon } from '@acorns/icons'
import { useRemoteStrings } from '@acorns/web-utils'

import { MOBILE_SHARE_BUTTON } from 'utils/testing/testIDs'

import { MobileShareButtonWrapper, WhiteButton } from './styled-components'

export const MobileShareButton = ({
  onShowShareModal,
}: {
  onShowShareModal: () => void
}): React.ReactElement => {
  const { getRemoteString } = useRemoteStrings()

  return (
    <MobileShareButtonWrapper>
      <WhiteButton
        data-testid={MOBILE_SHARE_BUTTON}
        onPress={onShowShareModal}
        styleType="light"
      >
        <AcornsIcon icon={AcornsIcon.Icon.UtilityShareIosFv} width={24} />
        <span>
          {getRemoteString({
            key: 'early.recap.gifts.no_gifts.cta',
          })}
        </span>
      </WhiteButton>
    </MobileShareButtonWrapper>
  )
}
